export default __webpack_public_path__ + "static/media/c-statement-box-img-01.14d1bc14.png";